import rolesApi from './api';
import roleActionsApi from '../roleactions/sagas/api';
import roleActionsToasts from '../roleactions/sagas/toasts';
import rolesToasts from './toasts';

export default [
  rolesApi(),
  rolesToasts(),
  roleActionsApi(),
  roleActionsToasts(),
];
